// extracted by mini-css-extract-plugin
export default {"input":"BasicInput_input__6l6KM","valid":"BasicInput_valid__Daket"};